<div class="sidebar d-flex flex-column flex-shrink-0 p-3 bg-white"
    style="width: 250px; height: 100vh; border-right: 1px solid #eee;">
    <a href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none">
        <span class="fs-4 fw-bold" style="color: var(--primary-color);">HexaDash</span>
    </a>
    <hr>
    <ul class="nav nav-pills flex-column mb-auto">
        <li class="nav-item">
            <a routerLink="/dashboard" routerLinkActive="active" class="nav-link link-dark">
                <i class="bi bi-grid me-2"></i> Dashboard
            </a>
        </li>
        <li>
            <a routerLink="/company" routerLinkActive="active" class="nav-link link-dark">
                <i class="bi bi-building me-2"></i> Companies
            </a>
        </li>
        <li>
            <a routerLink="/store" routerLinkActive="active" class="nav-link link-dark">
                <i class="bi bi-shop me-2"></i> Stores
            </a>
        </li>
        <li>
            <a routerLink="/customer" routerLinkActive="active" class="nav-link link-dark">
                <i class="bi bi-people me-2"></i> Customers
            </a>
        </li>
        <li>
            <a routerLink="/template" routerLinkActive="active" class="nav-link link-dark">
                <i class="bi bi-file-text me-2"></i> Templates
            </a>
        </li>
        <li>
            <a routerLink="/schedule" routerLinkActive="active" class="nav-link link-dark">
                <i class="bi bi-calendar-check me-2"></i> WhatsApp Scheduler
            </a>
        </li>
        <li>
            <a routerLink="/whatsapp-sent" routerLinkActive="active" class="nav-link link-dark">
                <i class="bi bi-check-circle me-2"></i> Sent Messages
            </a>
        </li>
    </ul>
</div>